"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconNeoDark = exports.iconNeoLight = exports.iconNovoDark = exports.iconNovo = exports.icon = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const icon = {
    color: color_const_1.default.pickledBluewood800,
    linkColor: color_const_1.default.steel700,
    hoverColor: color_const_1.default.dodgerBlue,
    selectedColor: color_const_1.default.dodgerBlue,
    disabledColor: color_const_1.default.dodgerBlue300,
    noLinkInvertColor: color_const_1.default.white,
    linkInvertColor: color_const_1.default.cloudyBlue,
    hoverInvertColor: color_const_1.default.white,
    selectedInvertColor: color_const_1.default.white,
    disabledInvertColor: color_const_1.default.steel700,
    size: size_const_1.default.medium,
    viewBox: size_const_1.default.viewBox,
};
exports.icon = icon;
const iconNovo = {
    color: light.icon01,
    linkColor: light.icon01,
    hoverColor: light.icon01,
    selectedColor: light.icon01,
    disabledColor: light.icon03,
    noLinkInvertColor: dark.icon01,
    linkInvertColor: dark.icon01,
    hoverInvertColor: dark.icon01,
    selectedInvertColor: dark.icon01,
    disabledInvertColor: dark.icon03,
    size: '24px',
    viewBox: size_const_1.default.viewBox,
};
exports.iconNovo = iconNovo;
const iconNovoDark = {
    ...iconNovo,
    color: dark.icon01,
    linkColor: dark.icon01,
    hoverColor: dark.icon01,
    selectedColor: dark.icon01,
    disabledColor: dark.icon03,
    noLinkInvertColor: light.icon01,
    linkInvertColor: light.icon01,
    hoverInvertColor: light.icon01,
    selectedInvertColor: light.icon01,
    disabledInvertColor: light.icon03,
};
exports.iconNovoDark = iconNovoDark;
const iconNeoLight = {
    ...iconNovo,
    color: neoLight.icon01,
    linkColor: neoLight.icon01,
    hoverColor: neoLight.icon01,
    selectedColor: neoLight.icon01,
    disabledColor: neoLight.icon03,
    noLinkInvertColor: neoDark.icon01,
    linkInvertColor: neoDark.icon01,
    hoverInvertColor: neoDark.icon01,
    selectedInvertColor: neoDark.icon01,
    disabledInvertColor: neoDark.icon03,
};
exports.iconNeoLight = iconNeoLight;
const iconNeoDark = {
    ...iconNovoDark,
    color: neoDark.icon01,
    linkColor: neoDark.icon01,
    hoverColor: neoDark.icon01,
    selectedColor: neoDark.icon01,
    disabledColor: neoDark.icon03,
    noLinkInvertColor: neoLight.icon01,
    linkInvertColor: neoLight.icon01,
    hoverInvertColor: neoLight.icon01,
    selectedInvertColor: neoLight.icon01,
    disabledInvertColor: neoLight.icon03,
};
exports.iconNeoDark = iconNeoDark;
